<template>
  <asc-label size="md" :value="value"></asc-label>
</template>

<script>
import AscLabel from '@/components/atoms/AscLabel'

export default {
  name: 'AscReportDate',

  components: {
    AscLabel,
  },

  props: {
    value: {
      type: String,
      required: true,
    },
  },
}
</script>
